<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title ">TOTAL Invoice Generated Bulan {{ tanggal_tampil }} (SEMUA PELANGGAN)
                            </h3>
                            
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <div class="info-box">
                                        <span class="info-box-icon bg-primary elevation-1">
                                            <i class="far fa-calendar"></i>
                                        </span>
                                        <div class="info-box-content">
                                            <span class="info-box-text">Generated</span>
                                            <span class="info-box-number mt-0"><small>Jumlah :</small> 
                                                {{ this.jlh_data_corpo+this.jlh_data_pppoe }}
                                            </span>
                                            <span class="info-box-number mt-0">
                                                {{ this.ttl_data_corpo+this.ttl_data_pppoe | toCurrency }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col">
                                    <div class="info-box">
                                        <span class="info-box-icon bg-yellow elevation-1">
                                            <i class="far fa-calendar-plus"></i>
                                        </span>
                                        <div class="info-box-content">
                                            <span class="info-box-text text-yellow">Unpaid</span>
                                            <span class="info-box-number mt-0"><small>Jumlah :</small> 
                                                {{ this.jlh_data_unpaid_corpo+this.jlh_data_unpaid_pppoe }}</span>
                                            <span class="info-box-number mt-0">
                                                {{ this.ttl_data_unpaid_corpo+this.ttl_data_unpaid_pppoe | toCurrency }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="info-box">
                                        <span class="info-box-icon bg-red elevation-1">
                                            <i class="far fa-calendar-times"></i>
                                        </span>
                                        <div class="info-box-content">
                                            <span class="info-box-text text-red">Overdue</span>
                                            <span class="info-box-number mt-0"><small>Jumlah :</small> 
                                                {{ this.jlh_data_overdue_corpo+this.jlh_data_overdue_pppoe }}
                                            </span>
                                            <span class="info-box-number mt-0">
                                                {{ this.ttl_data_overdue_corpo +this.ttl_data_overdue_pppoe | toCurrency }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix hidden-md-up"></div>
                            </div>

                            <div class="row pt-0 mt-0 mb-0 pb-0">
                                <div class="col">
                                    <div class="info-box">
                                        <span class="info-box-icon bg-green elevation-1">
                                            <i class="far fa-calendar-check"></i>
                                        </span>
                                        <div class="info-box-content">
                                            <span class="info-box-text text-green">Paid</span>
                                            <span class="info-box-number mt-0"><small>Jumlah :</small> 
                                                {{ this.jlh_data_paid_corpo+this.jlh_data_paid_pppoe }}
                                            </span>
                                            <span class="info-box-number mt-0">
                                                {{ this.ttl_data_paid_corpo+this.ttl_data_paid_pppoe | toCurrency }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="info-box">
                                        <span class="info-box-icon bg-green elevation-1">
                                            <i class="far fa-calendar-times"></i>
                                        </span>

                                        <div class="info-box-content">
                                            <span class="info-box-text text-red">Paid Overdue</span>
                                            <span class="info-box-number mt-0"><small>Jumlah :</small> 
                                                {{ this.jlh_data_paid_overdue_corpo+this.jlh_data_paid_overdue_pppoe }}
                                            </span>
                                            <span class="info-box-number mt-0">
                                                {{this.ttl_data_paid_overdue_corpo + this.ttl_data_paid_overdue_pppoe | toCurrency }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="info-box">
                                        <span class="info-box-icon bg-green elevation-1">
                                            <i class="far fa-calendar-times"></i>
                                        </span>
                                        <div class="info-box-content">
                                            <span class="info-box-text text-black">TOTAL PAID</span>
                                            <span class="info-box-number mt-0"><small>Jumlah :</small> 
                                                {{ this.jlh_data_paid_corpo + this.jlh_data_paid_pppoe + this.jlh_data_paid_overdue_corpo+this.jlh_data_paid_overdue_pppoe }}
                                            </span>
                                            <span class="info-box-number mt-0">
                                                {{ this.ttl_data_paid_corpo + this.ttl_data_paid_pppoe + this.ttl_data_paid_overdue_corpo + this.ttl_data_paid_overdue_pppoe | toCurrency }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix hidden-md-up"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title ">Daftar Invoice Generated Bulan {{ tanggal_tampil }}</h3>
                            <div class="card-tools">
                                <v-dialog ref="dialog" v-model="modaltgl" :return-value.sync="tanggal_query" persistent
                                    width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field style="margin-top:0px;padding-top:0px" v-model="tanggal_query"
                                            label="" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="tanggal_query" type="month" scrollable :max="dateMax">
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="modaltgl = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary" @click="ubahTanggalTampil($refs)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </div>
                        </div>
                        <v-app>
                            <v-content>
                                <div class="card-body ">
                                    <ul class="nav nav-tabs custom-tabs" id="custom-content-above-tab" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" 
                                                id="custom-content-above-home-tab"
                                                data-toggle="pill" 
                                                href="#custom-content-above-home" 
                                                role="tab"
                                                aria-controls="custom-content-above-home" 
                                                aria-selected="true">
                                                <i class="fa fa-user-alt"></i> 
                                                <span>PPPOE</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" 
                                                id="custom-content-above-profile-tab" 
                                                data-toggle="pill"
                                                href="#custom-content-above-profile" 
                                                role="tab"
                                                aria-controls="custom-content-above-profile" 
                                                aria-selected="false">
                                                <i class="fa fa-users"></i> 
                                                <span>CORPORATE</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <div class="tab-custom-content"></div>
                                    <div class="tab-content" id="custom-content-above-tabContent">
                                        <div class="tab-pane fade show active" id="custom-content-above-home"
                                            role="tabpanel" aria-labelledby="custom-content-above-home-tab">
                                            <div class="row">
                                                <div class="col">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-primary elevation-1">
                                                            <i class="far fa-calendar"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text">Generated</span>
                                                            <span class="info-box-number mt-0"><small>Jumlah :</small>
                                                                {{ this.jlh_data_pppoe }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ this.ttl_data_pppoe | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-yellow elevation-1">
                                                            <i class="far fa-calendar-plus"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text text-yellow">Unpaid</span>
                                                            <span class="info-box-number mt-0"><small>Jumlah :</small>
                                                                {{ this.jlh_data_unpaid_pppoe }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ this.ttl_data_unpaid_pppoe | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col ">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-red elevation-1">
                                                            <i class="far fa-calendar-times"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text text-red">Overdue</span>
                                                            <span class="info-box-number mt-0"><small>Jumlah :</small>
                                                                {{ this.jlh_data_overdue_pppoe }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ this.ttl_data_overdue_pppoe | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="clearfix hidden-md-up"></div>
                                            </div>
                                            <div class="row pt-0 mt-0 mb-0 pb-0">
                                                <div class="col">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-green elevation-1">
                                                            <i class="far fa-calendar-check"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text text-green">Paid</span>
                                                            <span class="info-box-number mt-0">
                                                                <small>Jumlah :</small> {{ this.jlh_data_paid_pppoe }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ this.ttl_data_paid_pppoe | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-green elevation-1">
                                                            <i class="far fa-calendar-times"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text text-red">Paid Overdue</span>
                                                            <span class="info-box-number mt-0">
                                                                <small>Jumlah :</small> {{ this.jlh_data_paid_overdue_pppoe }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ this.ttl_data_paid_overdue_pppoe | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-green elevation-1">
                                                            <i class="far fa-calendar-times"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text text-black">TOTAL PAID</span>
                                                            <span class="info-box-number mt-0">
                                                                <small>Jumlah :</small> 
                                                                {{ this.jlh_data_paid_pppoe + this.jlh_data_paid_overdue_pppoe }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ (this.ttl_data_paid_pppoe + this.ttl_data_paid_overdue_pppoe) | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="clearfix hidden-md-up"></div>
                                            </div>
                                            <v-row class="mb-1">
                                                <v-col md="4">
                                                    <v-select 
                                                        v-model="filter_pppoe" 
                                                        :items="filter_plg"
                                                        item-text="text" 
                                                        item-value="id" 
                                                        label="Pilih Filter" 
                                                        outlined
                                                        dense 
                                                        return-object 
                                                        class="w-100">
                                                    </v-select>
                                                </v-col>

                                                <v-text-field
                                                    v-model="cari_dt_plg"
                                                    label="Cari"
                                                    class="w-100 col-md-2 ml-auto mb-2"
                                                    outlined
                                                    dense
                                                    hide-details
                                                >
                                                </v-text-field>
                                            </v-row>

                                            <v-data-table
                                                @update:group-desc="tableGrouping"
                                                :headers="headers"
                                                :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, -1] }"
                                                :items="datas"
                                                :items-per-page="25"
                                                item-key="id"
                                                sort-by="no"
                                                class="elevation-1"
                                                show-group-by
                                                :search="cari_dt_plg"
                                            >
                                                <!-- Group Header -->
                                                <template v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
                                                    <td :colspan="headers.length - 1">
                                                        <v-btn @click="toggle" x-small icon :ref="group">
                                                            <v-icon v-if="isOpen">mdi-minus</v-icon>
                                                            <v-icon v-else>mdi-plus</v-icon>
                                                        </v-btn>
                                                        <span class="mx-3">
                                                            Status : <span class="font-weight-bold">{{ group }}</span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <v-btn @click="remove" x-small icon>
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </template>

                                                <!-- Kolom No dengan Zerofill -->
                                                <template v-slot:item.no="{ item }">
                                                    {{ item.no | zerofill }}
                                                </template>

                                                <!-- Kolom Total Bayar dengan Format Mata Uang -->
                                                <template v-slot:item.total_bayar="{ item }">
                                                   <strong> {{ item.total_bayar | toCurrency }}</strong>
                                                </template>

                                                <!-- Kolom Status Pembayaran -->
                                                <template v-slot:item.status="{ item }">
                                                    <span class="badge badge-success" v-if="item.status_bayar == '1'">Paid</span>
                                                    <span class="badge badge-danger" v-else-if="item.status_bayar == '0' && getTanggalHariIni() > item.tanggal_batas_bayar">Overdue</span>
                                                    <span class="badge badge-warning" v-else-if="item.status_bayar == '0' && getTanggalHariIni() <= item.tanggal_batas_bayar">Unpaid</span>
                                                </template>

                                                <!-- Tampilan Jika Tidak Ada Data -->
                                                <template v-slot:no-data>
                                                    <h6>Data Tidak Ditemukan</h6>
                                                </template>
                                            </v-data-table>
                                        </div>

                                        <div class="tab-pane fade" id="custom-content-above-profile" role="tabpanel" aria-labelledby="custom-content-above-profile-tab">
                                            <div class="row">
                                                <!-- Generated -->
                                                <div class="col">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-primary elevation-1">
                                                            <i class="far fa-calendar"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text">Generated</span>
                                                            <span class="info-box-number mt-0">
                                                                <small>Jumlah :</small> {{ this.jlh_data_corpo }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ this.ttl_data_corpo | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Unpaid -->
                                                <div class="col">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-yellow elevation-1">
                                                            <i class="far fa-calendar-plus"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text text-yellow">Unpaid</span>
                                                            <span class="info-box-number mt-0">
                                                                <small>Jumlah :</small> {{ this.jlh_data_unpaid_corpo }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ this.ttl_data_unpaid_corpo | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Overdue -->
                                                <div class="col">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-red elevation-1">
                                                            <i class="far fa-calendar-times"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text text-red">Overdue</span>
                                                            <span class="info-box-number mt-0">
                                                                <small>Jumlah :</small> {{ this.jlh_data_overdue_corpo }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ this.ttl_data_overdue_corpo | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Fix for small devices -->
                                                <div class="clearfix hidden-md-up"></div>
                                            </div>

                                            <div class="row pt-0 mt-0 mb-0 pb-0">
                                                <!-- Paid -->
                                                <div class="col">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-green elevation-1">
                                                            <i class="far fa-calendar-check"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text text-green">Paid</span>
                                                            <span class="info-box-number mt-0">
                                                                <small>Jumlah :</small> {{ this.jlh_data_paid_corpo }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ this.ttl_data_paid_corpo | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Overdue (Paid Overdue) -->
                                                <div class="col">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-red elevation-1">
                                                            <i class="far fa-calendar-times"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text text-red">Overdue</span>
                                                            <span class="info-box-number mt-0">
                                                                <small>Jumlah :</small> {{ this.jlh_data_paid_overdue_corpo }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ this.ttl_data_paid_overdue_corpo | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Total Paid -->
                                                <div class="col">
                                                    <div class="info-box">
                                                        <span class="info-box-icon bg-black elevation-1">
                                                            <i class="far fa-calendar-times"></i>
                                                        </span>
                                                        <div class="info-box-content">
                                                            <span class="info-box-text text-black">TOTAL PAID</span>
                                                            <span class="info-box-number mt-0">
                                                                <small>Jumlah :</small> {{ this.jlh_data_paid_corpo + this.jlh_data_paid_overdue_corpo }}
                                                            </span>
                                                            <span class="info-box-number mt-0">
                                                                {{ (this.ttl_data_paid_corpo + this.ttl_data_paid_overdue_corpo) | toCurrency }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Fix for small devices -->
                                                <div class="clearfix hidden-md-up"></div>
                                            </div>

                                            <v-row class="mb-1">
                                                <v-col md="4">
                                                    <v-select 
                                                        v-model="filter_corp" 
                                                        :items="filter_plg"
                                                        item-text="text" 
                                                        item-value="id" 
                                                        label="Pilih Filter" 
                                                        outlined
                                                        dense 
                                                        return-object 
                                                        class="w-100">
                                                    </v-select>
                                                </v-col>

                                                <v-text-field
                                                    v-model="cari_dt_plg_corp"
                                                    label="Cari"
                                                    class="w-100 col-md-2 ml-auto mb-2"
                                                    outlined
                                                    dense
                                                    hide-details
                                                >
                                                </v-text-field>
                                            </v-row>

                                            <v-data-table
                                                @update:group-desc="tableGrouping"
                                                :headers="headers_corp"
                                                :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, -1] }"
                                                :items="datas_corp"
                                                :items-per-page="25"
                                                item-key="id"
                                                sort-by="no"
                                                class="elevation-1"
                                                show-group-by
                                                :search="cari_dt_plg_corp"
                                            >
                                                <!-- Header Grouping -->
                                                <template v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
                                                    <td :colspan="headers.length - 1">
                                                        <v-btn @click="toggle" x-small icon>
                                                            <v-icon v-if="isOpen">mdi-minus</v-icon>
                                                            <v-icon v-else>mdi-plus</v-icon>
                                                        </v-btn>
                                                        <span class="mx-3">
                                                            Status: <span class="font-weight-bold">{{ group }}</span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <v-btn @click="remove" x-small icon>
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </template>

                                                <!-- Kolom Nomor -->
                                                <template v-slot:item.no="{ item }">
                                                    {{ item.no | zerofill }}
                                                </template>

                                                <!-- Kolom Total Bayar -->
                                                <template v-slot:item.total_bayar="{ item }">
                                                    {{ item.total_bayar | toCurrency }}
                                                </template>

                                                <!-- Kolom Status -->
                                                <template v-slot:item.status="{ item }">
                                                    <span class="badge badge-success" v-if="item.status_bayar == '1'">Paid</span>
                                                    <span class="badge badge-danger" v-else-if="item.status_bayar == '0' && getTanggalHariIni() > item.tanggal_batas_bayar">Overdue</span>
                                                    <span class="badge badge-warning" v-else>Unpaid</span>
                                                </template>

                                                <!-- Tidak Ada Data -->
                                                <template v-slot:no-data>
                                                    <h6>Data Tidak Ditemukan</h6>
                                                </template>
                                            </v-data-table>
                                        </div>
                                    </div>
                                </div>
                            </v-content>
                        </v-app>
                        <!-- /.card-body -->
                        <div class="card-footer"> </div>
                    </div>
                    <!-- /.card -->
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    export default {
        data() {
            return {
                dateMax: new Date().toISOString().substr(0, 7),
                tanggal_query: new Date().toISOString().substr(0, 7),
                tanggal_tampil: '',
                filter_corp: "0",
                filter_pppoe: "0",
                filter_plg: [
                    { text: 'Semua', id: '0' },
                    { text: 'Harga Full', id: '1' },
                    { text: 'Harga Prorate', id: '2' },
                ],
                jlh_data_unpaid_pppoe: '0',
                ttl_data_unpaid_pppoe: '0',
                jlh_data_paid_pppoe: '0',
                ttl_data_paid_pppoe: '0',
                jlh_data_overdue_pppoe: '0',
                ttl_data_overdue_pppoe: '0',
                jlh_data_paid_overdue_pppoe: '0',
                ttl_data_paid_overdue_pppoe: '0',
                jlh_data_pppoe: '0',
                ttl_data_pppoe: '0',
                jlh_data_unpaid_corpo: '0',
                ttl_data_unpaid_corpo: '0',
                jlh_data_paid_corpo: '0',
                ttl_data_paid_corpo: '0',
                jlh_data_overdue_corpo: '0',
                ttl_data_overdue_corpo: '0',
                jlh_data_paid_overdue_corpo: '0',
                ttl_data_paid_overdue_corpo: '0',
                jlh_data_corpo: '0',
                ttl_data_corpo: '0',
                jlh_invoice: '0',
                ttl_invoice: '0',
                cari_dt_plg_corp: '',
                cari_dt_plg: '',
                checkbox: false,
                datas_corp: [],
                datas: [],
                form: new Form({
                    invoice: {
                        id: '',
                        username: '',
                        nama: '',
                        nama_tempat: '',
                        paket: '',
                        harga_paket: '',
                        diskon: '',
                        ppn: '',
                        tagihan: '',
                        tanggal: '',
                        tanggal_batas_bayar: '',
                        total_bayar: '0',
                        total: '0',
                        status_bayar: '0',
                        print_pajak: '0',
                        print_diskon: '0',
                        kickback: '0',
                        ppn_keluaran: '0',
                        pph23: '0',
                        zakat: '0',
                        downtime: '0',
                        downtime_rp: '0',
                        keterangan: '',
                        kantor_id: '',
                    }
                }),
                modaltgl: false,
                menu2: false,
                menu: false,
                tipe_pelanggan_edit: '0',
                adaeror: [],
            }
        },
        computed: {
            headers() {
                return [
                    { text: 'No Inv', value: 'id', groupable: false, },
                    { text: 'Tempat Instalasi', value: 'pelanggan_internet.nama', groupable: false, },
                    {
                        text: 'Tipe Invoice', value: 'tipe_invoice_val', groupable: false, sortable: false, align: " d-none", filter: value => {
                            if (this.filter_pppoe.id == 1) {
                                return value === "Penuh";
                            } else if (this.filter_pppoe.id == 2) {
                                return value === "Prorate";
                            } else {
                                return true;
                            }
                        },
                    },
                    { text: 'Jumlah Bayar', value: 'total_bayar', groupable: false, align: "end", class: "text-right"},
                    { text: 'Status', value: 'status', sortable: true, groupable: false, align: "center", class: "text-center"},
                ]
            },

            headers_corp() {
                return [
                    { text: 'No Inv', value: 'id', groupable: false, },
                    { text: 'Tempat Instalasi', value: 'pelanggan_internet.nama', groupable: false, },
                    {
                        text: 'Tipe Invoice', value: 'tipe_invoice_val', groupable: false, sortable: false, align: " d-none", filter: value => {
                            if (this.filter_corp.id == 1) {
                                return value === "Penuh";
                            } else if (this.filter_corp.id == 2) {
                                return value === "Prorate";
                            } else {
                                return true;
                            }
                        },
                    },
                    { text: 'Jumlah Bayar', value: 'total_bayar', groupable: false, align: "end", class: "text-right"},
                    { text: 'Status', value: 'status', sortable: true, groupable: false, align: "center", class: "text-center"},
                ]
            },
        },

        methods: {

            generate_invoice() {
                this.$Progress.start();
                if (this.$gate.isAdmin()) {
                    axios.get("api/invoice/generate")
                    .then((data) => {
                        Toast.fire({
                            icon: 'success',
                            title: "Generate Invoice Berhasil"
                        });
                        this.loadUnpaid();
                        this.$Progress.finish();
                    })
                    .catch(e => {
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occured! Please try again'
                        });

                        this.$Progress.fail();
                    });
                }
            },

            ubahTanggalTampil(e) {
                e.dialog.save(this.tanggal_query);
                this.loadUnpaid();
            },

            getTanggalHariIni() {
                const today = new Date();
                const date = today.getFullYear() + '-' + (String(today.getMonth() + 1).padStart(2, '0')) + '-' + String(today.getDate()).padStart(2, '0');;
                return date;
            },

            downloadFile(response, filename) {
                // It is necessary to create a new blob object with mime-type explicitly set
                // otherwise only Chrome works like it should
                var newBlob = new Blob([response.data], { type: 'application/pdf' });

                // IE doesn't allow using a blob object directly as link href
                // instead it is necessary to use msSaveOrOpenBlob
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(newBlob);
                    return
                }

                // For other browsers:
                // Create a link pointing to the ObjectURL containing the blob.
                const data = window.URL.createObjectURL(newBlob);
                var link = document.createElement('a');
                link.href = data;
                link.download = filename + '.pdf'
                document.body.appendChild(link);
                link.click();
                setTimeout(function () {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    window.URL.revokeObjectURL(data);
                }, 100)
            },

            printInvoice(item) {
                this.$Progress.start();
                let namaFileDownload = "Invoice " + item.pelanggan_internet.nama + " " + item.bulan_pemakaian;
                axios.get('api/invoice/printpdf?id_invoice=' + item.id, { responseType: 'blob' }).then(response => {
                    this.downloadFile(response, namaFileDownload);
                    this.$Progress.finish();
                }, response => {
                    Toast.fire({
                        icon: 'error',
                        title: data.data.data ? data.data.data : "Error!. Download Invoice Gagal."
                    });
                    this.$Progress.fail();
                });
            },

            preventArrow(e) {
                if (e.which === 38 || e.which === 40) {
                    e.preventDefault();
                }
                if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
                    e.preventDefault();
                }
                // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
            },
            
            tableGrouping(e) {
                if (e.length) {
                    this.table_group_state = true;
                } else {
                    this.table_group_state = false;
                }
            },

            loadUnpaid() {
                let tahunpaid = this.tanggal_query.substr(0, 4);
                let bulanpaid = this.tanggal_query.substr(-2, 2);
                if (this.$gate.isAllowed("is_invoice")) {

                    if (this.$gate.dataType('1')) {
                        axios.get("api/invoice/list_generated?tipe=1&tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => (this.datas = data.data));
                        axios.get("api/invoice/list_generated_count?tipe=1&tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => {
                            this.jlh_data_pppoe = parseInt(data.data[0].jumlah_generated ? data.data[0].jumlah_generated : 0);
                            this.ttl_data_pppoe = parseInt(data.data[0].total_generated ? data.data[0].total_generated : 0);
                            this.jlh_data_unpaid_pppoe = parseInt(data.data[0].jumlah_unpaid ? data.data[0].jumlah_unpaid : 0);
                            this.ttl_data_unpaid_pppoe = parseInt(data.data[0].total_unpaid ? data.data[0].total_unpaid : 0);
                            this.jlh_data_paid_pppoe = parseInt(data.data[0].jumlah_paid ? data.data[0].jumlah_paid : 0);
                            this.ttl_data_paid_pppoe = parseInt(data.data[0].total_paid ? data.data[0].total_paid : 0);
                            this.jlh_data_overdue_pppoe = parseInt(data.data[0].jumlah_overdue ? data.data[0].jumlah_overdue : 0);
                            this.ttl_data_overdue_pppoe = parseInt(data.data[0].total_overdue ? data.data[0].total_overdue : 0);
                            this.jlh_data_paid_overdue_pppoe = parseInt(data.data[0].jumlah_paid_overdue ? data.data[0].jumlah_paid_overdue : 0);
                            this.ttl_data_paid_overdue_pppoe = parseInt(data.data[0].total_paid_overdue ? data.data[0].total_paid_overdue : 0);
                        });
                    }
                    if (this.$gate.dataType('2')) {
                        axios.get("api/invoice/list_generated?tipe=2&tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => (this.datas_corp = data.data));
                        axios.get("api/invoice/list_generated_count?tipe=2&tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => {
                            this.jlh_data_corpo = parseInt(data.data[0].jumlah_generated ? data.data[0].jumlah_generated : 0);
                            this.ttl_data_corpo = parseInt(data.data[0].total_generated ? data.data[0].total_generated : 0);
                            this.jlh_data_unpaid_corpo = parseInt(data.data[0].jumlah_unpaid ? data.data[0].jumlah_unpaid : 0);
                            this.ttl_data_unpaid_corpo = parseInt(data.data[0].total_unpaid ? data.data[0].total_unpaid : 0);
                            this.jlh_data_paid_corpo = parseInt(data.data[0].jumlah_paid ? data.data[0].jumlah_paid : 0);
                            this.ttl_data_paid_corpo = parseInt(data.data[0].total_paid ? data.data[0].total_paid : 0);
                            this.jlh_data_overdue_corpo = parseInt(data.data[0].jumlah_overdue ? data.data[0].jumlah_overdue : 0);
                            this.ttl_data_overdue_corpo = parseInt(data.data[0].total_overdue ? data.data[0].total_overdue : 0);
                            this.jlh_data_paid_overdue_corpo = parseInt(data.data[0].jumlah_paid_overdue ? data.data[0].jumlah_paid_overdue : 0);
                            this.ttl_data_paid_overdue_corpo = parseInt(data.data[0].total_paid_overdue ? data.data[0].total_paid_overdue : 0);
                        });
                    }
                }
                this.tanggal_tampil = this.getBulan(this.tanggal_query);
            },

            getBulan(tanggal) {
                var tgltemp = new Date(tanggal);
                var tahun = tgltemp.getFullYear();
                var bulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

                return (bulan[tgltemp.getMonth()] + " " + tahun);
            },
        },

        mounted() {},

        created() {
            this.$Progress.start();
            this.loadUnpaid();
            this.$Progress.finish();
        },
    }
</script>

<style scoped>
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .tanpawrap {
        white-space: nowrap;
    }

    .info-box {
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* Smooth shadow */
        border-radius: 10px; /* Rounded corners */
        transition: all 0.3s ease-in-out;
    }

    .info-box:hover {
        box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.15); /* Slightly stronger shadow on hover */
        transform: translateY(-2px);
    }

    .info-box-icon {
        border-radius: 8px; /* Softer edges */
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .info-box-content {
        padding: 8px 15px;
    }

    .info-box-text {
        font-weight: 600;
        font-size: 14px;
    }

    .info-box-number {
        font-size: 16px;
        font-weight: bold;
    }
</style>